module.exports = __webpack_public_path__ + "img/help.8557a1d1.svg";